import {
  useIsMobile,
  WSButton,
  WSGrid,
  WSPage,
  WSPreview,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import imageAccount from "../../assets/images/wallet-preview-account.png";
import imageCards from "../../assets/images/wallet-preview-cards.png";
import imageTable from "../../assets/images/wallet-preview-table.png";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { OverlaySpinner } from "../../components/OverlaySpinner";
import { useVerificationUpgrade } from "../../Invoices/components/VerificationUpgrade/VerificationUpgrade";
import { useUserId } from "../../query/hooks/helpers";
import { useFeatureFlags } from "../../query/hooks/useFeatureFlags";
import { useUpdateActivity } from "../../query/users/mutations";
import { useActivities } from "../../query/users/queries";
import styles from "./WalletPreview.module.scss";

export const WalletPreview: React.FC<RouteComponentProps> = ({ history }) => {
  const isMobile = useIsMobile();
  const memberId = useUserId();
  const [updateActivity] = useUpdateActivity(memberId);
  const activityQuery = useActivities(memberId);
  const {
    requestVerification,
    requestVerificationMeta,
    isBankingRequested
  } = useVerificationUpgrade();
  const featureFlags = useFeatureFlags();

  return (
    <WSPage>
      {requestVerificationMeta.isLoading && <OverlaySpinner />}
      <BrowserPageTitle title="Wallet - Preview" />
      <WSGrid.Container>
        <WSGrid.Item L={6}>
          <WSText.Heading2 mb="S">Wingspan Wallet</WSText.Heading2>
          <WSText mb={isMobile ? "M" : "XL"}>
            Add funds to a business bank account within Wingspan. Use virtual
            cards to perform transactions, make payments and so much more.
          </WSText>
          <WSButton.Primary
            loading={activityQuery.isLoading}
            name="getStarted"
            onAsyncClick={async () => {
              if (activityQuery.data?.flows.paymentsSetup?.complete) {
                try {
                  if (
                    featureFlags.data?.verificationsByFeature &&
                    !isBankingRequested
                  ) {
                    await requestVerification({
                      banking: true
                    });
                  }

                  await updateActivity({
                    flows: {
                      walletSetup: {
                        complete: false,
                        version: 2,
                        currentStep: 1,
                        totalSteps: 2
                      }
                    }
                  });
                  history.push("/member/wallet/set-up/distribution");
                } catch (e) {
                  console.error(e);
                }
              } else {
                history.push("/member/wallet/set-up/payments");
              }
            }}
          >
            Get Started
          </WSButton.Primary>
        </WSGrid.Item>
      </WSGrid.Container>

      <WSPreview
        className={styles.previewImage}
        mt={isMobile ? "L" : "XXL"}
        list={[
          {
            title: "Business banking made better",
            description:
              "Receive your payments 1-2 day sooner. No account, transaction, minimum balance or hidden fees. Virtual debit card via Apple Pay and Google Pay.",
            image: imageAccount
          },
          {
            title: "Save big on your taxes with write-offs",
            description:
              "Automatic write-offs of business expenses, fully integrated with Wingspan Income & Expenses.",
            image: imageTable
          },
          {
            title: "Over 40,000 ATMs",
            description:
              "Fee-free cash deposits and withdrawals at 40,000 ATMs nationwide. Unlimited ACH and wire transfers for free.",
            image: imageCards
          }
        ]}
      />
    </WSPage>
  );
};
